import { Component, HostListener, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ActiveService } from '../../share/service/active.service';
import { NavigationService } from '../../share/service/navigation.service';

@Component({
  selector: 'app-active',
  templateUrl: './active.component.html',
  styleUrls: ['./active.component.scss'],
})
export class ActiveComponent implements OnInit, OnDestroy, AfterViewInit {
  @HostListener('window:scroll', ['$event']) onScroll() {
    if (this.activeService.loading) {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        const loaderLine = document.querySelector<HTMLElement>('.loader-line');
        if (loaderLine) {
          loaderLine.style.position = 'fixed';
        }
      } else {
        const loaderLine = document.querySelector<HTMLElement>('.loader-line');
        if (loaderLine) {
          loaderLine.style.position = 'relative';
        }
      }
    }
  }

  windowCouponAmount: string;

  constructor(
    public activeService: ActiveService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.activeService.initComponent();
    this.windowCouponAmount = window['wf_sso_coupon_amount'];
  }

  ngAfterViewInit() {
    this.navigationService.restoreScrollPosition(100);
  }

  ngOnDestroy() {
    this.activeService.ngOnDestroy();
  }

  postFilter() {
    this.activeService.postFilter();
  }

  skipToContent(): void {
    this.navigationService.skipToMainContent();
  }
}

